import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversationMentionUnread } from 'entities/Conversation/api/types'
import { Conversation } from 'entities/Conversation/model/Conversation'
import { Message } from 'entities/Message/model/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ILocalTypeInbox } from 'entities/Inbox'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import { type ConversationListStore } from 'pages/conversations/ui/ConversationList'

export const useEventConversationMentionUnread = (
  conversationListStore: ConversationListStore,
  view: ILocalTypeInbox
) => {
  const entities = useEntitiesContext()
  const { conversationStore } = entities
  const handler = (data: IResponseConversationMentionUnread) => {
    const item = new Conversation(data.conversation, entities)
    const message = new Message(
      {
        message: data.conversation.recent_message,
      },
      entities
    )
    const { conversationSearchStore, filtersStore } = conversationListStore
    const update = () => {
      const checked = Boolean(conversationStore.getItem(data.conversation_id)?.checked)
      conversationStore.updateItem(data.conversation, { updateMentionsCount: true })
      conversationStore.getItem(data.conversation_id)?.handleChecked(checked)
    }

    runInAction(() => {
      // Smart view
      if (view === 'smart_view') {
        const smartView = entities.inboxesStore.localInboxes.currentSmartView

        if (!smartView) return
        if (!checkFilterSmartView(item.smartViewFilterParams, smartView.filters)) return
        if (!filtersStore.isShowConversation(item, message)) return

        update()

        return
      }

      // Old search
      if (conversationSearchStore.isActive) {
        const conversation = conversationStore.getItem(data.conversation_id)

        if (conversation) {
          conversationStore.updateItem(data.conversation, { updateMentionsCount: true })
        }

        return
      }

      // Default
      if (
        entities.inboxesStore.currentInbox?.type === 'inbox' &&
        item.inbox_id !== entities.inboxesStore.currentInboxId &&
        view !== 'quick'
      )
        return

      if (!filtersStore.isShowConversation(item, message)) return

      update()
    })
  }

  useEffect(() => entities.websocket.on(WebsocketEvent.ConversationMentionUnread, handler), [view])
}
